import { useSuspenseQuery } from '@tanstack/react-query';
import { Element, Item } from '@outdoria/types';
import { fetcher } from '../utils';
import { ITEM } from '../queryKeys';

type Data = {
  item: Item;
  elements: Element['element_id'][];
};
export const useGetItemById = (item_id?: string) => {
  const queryFn = async (): Promise<Data> => {
    const res = await fetcher(`/v2/items/${item_id}`);
    return res.json();
  };

  const { data, isLoading, isFetched, isError } = useSuspenseQuery<
    Data,
    unknown,
    Data,
    string[]
  >({
    queryKey: [...ITEM, item_id!],
    queryFn,
  });

  return { data, isLoading, isFetched, isError };
};
